import axios from "axios";
import config from "../../../config/config";
import * as mocks from "./register.mocks";
import { RegisterRequest, RegisterResponse } from "./auth.interfaces";

const API_URL = `${config.apiBaseUrl}/register`;

const apiRegister = async (request: RegisterRequest): Promise<RegisterResponse> => {
  try {
    const response = await axios.post<RegisterResponse>(API_URL, request);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error during registration:", error.message);
    } else {
      console.error("Unexpected error during registration:", error);
    }
    throw error;
  }
};

export const registerStudent = async (
  name: string,
  email: string,
  password: string,
  passwordConfirmation: string
): Promise<RegisterResponse> => {
  const request: RegisterRequest = {
    name,
    email,
    password,
    passwordConfirmation
  };
  
  return config.useRealApi ? apiRegister(request) : mocks.registerStudent(request);
};
